import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  title: {
    font: 'normal normal bold 21px/28px Roboto',
    textAlign: 'right',
    height: '80px'
  }
}));
